import type { FC } from 'react';
import { lazy } from 'react';
import { useParams } from 'react-router-dom';
import { usePublicStorageLocations } from 'src/apis/storage/use-public-storage-locations';
import { useStorageLocationDetails } from 'src/apis/storage/use-storage-location-details';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { storageLocationsEmptyParams } from 'src/pages/storage/locations-new/utils';

const Page = lazy(() => import('./page'));

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageLocationDetails: FC<Props> = ({ storageServiceRoot }) => {
  const { locationId } = useParams<{ locationId: string }>();

  const storageLocations = usePublicStorageLocations({
    storageServiceRoot,
    params: storageLocationsEmptyParams,
  });
  const storageLocationDetails = useStorageLocationDetails({
    storageLocations,
    locationId,
  });
  if (
    storageLocationDetails.response === null ||
    storageLocations.response === null
  )
    return <PageSpinner />;

  return <Page storageLocationDetails={storageLocationDetails} />;
};
